const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateCheckoutInput(email) {
  if (!email?.trim()) {
    return "Please enter your email address.";
  }
  if (!emailRegex.test(email)) {
    return "Please enter a valid email address.";
  }
  return null;
}
